<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-09 17:06:30
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'output' ? 'type-activite' : ''"
          @click="pageType = 'output'"
        >
          产量
        </div>
        <div
          :class="pageType === 'pondHarvest' ? 'type-activite' : ''"
          @click="pageType = 'pondHarvest'"
        >
          塘口收获情况
        </div>
      </div>
      <!-- 产量 -->
      <OutputPage v-if="pageType === 'output'" />
      <!-- 塘口收获情况 -->
      <PondHarvest v-if="pageType === 'pondHarvest'" />
    </div>
  </div>
</template>

<script>
import OutputPage from "./ym-harvest-output/ym-harvest-output.vue";
import PondHarvest from "./ym-harvest-pond.vue";
export default {
  name: "ym-harvest",
  data() {
    return {
      pageType: "output",
    };
  },
  computed: {},
  methods: {},
  components: {
    OutputPage,
    PondHarvest,
  },
};
</script>

<style lang="less" scoped>
</style>